import { render } from "./Cbhiaboutpage.vue?vue&type=template&id=44470864&scoped=true"
import script from "./Cbhiaboutpage.vue?vue&type=script&lang=js"
export * from "./Cbhiaboutpage.vue?vue&type=script&lang=js"

import "./Cbhiaboutpage.vue?vue&type=style&index=0&id=44470864&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44470864"]])

export default __exports__